import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    let count = localStorage.getItem('visitorCount');
    if (!count) {
      count = 1;
    } else {
      count = parseInt(count) + 1;
    }
    localStorage.setItem('visitorCount', count);
    setVisitorCount(count);
  }, []);

  return (
    <div id="footer_wrapper">
      <div className="footer">
        <div className="fott-nav">
          <ul className="footer-nav">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/rtinew/">RTI</Link></li>
            <li><Link to="/circular/">Circular</Link></li>
            <li><Link to="/contact-us/">Contact Us</Link></li>
            <li><Link to="/sitemap/">Sitemap</Link></li>
            <li><Link to="/privacy-policy/">Privacy Policy</Link></li>
            <li><Link to="/broken-link/">Broken Link Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="whitee-footer">
        <div className="footer-bottom">
          <p className="left-text">@ Maintained By Computer Section, RO Nashik.</p>
          <p className="visitor-counter">All Rights Reserved.</p>
          <p className="right-text">Total Visitors: <strong>{visitorCount}</strong></p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
